import request from '@/utils/request'

const groupApi = {
  group_list: '/electricity_meter/group/',
  group_create: 'electricity_meter/group/',
  group_update: '/electricity_meter/group/',
  group_delete: '/electricity_meter/group/',
  group_record_list: '/electricity_meter/group/record/',
  group_record_create: 'electricity_meter/group/record/',
  group_record_update: '/electricity_meter/group/record/',
  group_record_delete: '/electricity_meter/group/record/'
}

/**
 * 列表
 */
export function group_list (parameter) {
  return request({
    url: groupApi.group_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function group_create (parameter) {
  return request({
    url: groupApi.group_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function group_update (parameter, group_id) {
  return request({
    url: groupApi.group_update + group_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function group_delete (group_id) {
  return request({
    url: groupApi.group_delete + group_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 列表
 */
export function group_record_list (parameter) {
  return request({
    url: groupApi.group_record_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 添加
 */
export function group_record_create (parameter) {
  return request({
    url: groupApi.group_record_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function group_record_update (parameter, group_id) {
  return request({
    url: groupApi.group_record_update + group_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function group_record_delete (group_id) {
  return request({
    url: groupApi.group_record_delete + group_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
